import React, { Fragment, useState } from 'react';
import { isClient } from '../../lib/helper/authorisation';

const HoverableText = ({ note, onLineClick, snipAtIndex = false, enableSnip = false, classes = 'invoice-batch-single__note-content' }) => {
  const [showText, setShowText] = useState(false);
  const handleLineClick = (index) => {
    if (isClient() || !enableSnip) {
      return;
    }
    onLineClick({ index });
    setShowText(false);
  };
  return (
    <>
      <p className={`${classes} ${enableSnip ? 'snippable' : ''}`}>
        {note?.note &&
          note.note.split('\n').map((item, index) => (
            <Fragment key={index}>
              <span
                className={`hoverable-line ${!showText && !enableSnip && !!snipAtIndex && index >= snipAtIndex ? 'd-none' : ''}`}
                onClick={() => handleLineClick(index)}>
                {item}
              </span>
              <br className={!showText && !enableSnip && !!snipAtIndex && index >= snipAtIndex ? 'd-none' : ''} />
            </Fragment>
          ))}
      </p>
      {!isClient() && !showText && !enableSnip && snipAtIndex !== false && (
        <button className={'btn btn-xs btn-info w-auto'} onClick={() => setShowText(!showText)}>
          Show Hidden Note Text
        </button>
      )}
    </>
  );
};

export default HoverableText;
